<script>
import Layout from '@layouts/loggedin.vue'
import AddNewUsers from '@adminUsers/mixins/add-new-users-company.vue'

export default {
  components: {
    Layout,
  },
  mixins: [AddNewUsers],
  data() {
    return {
      invitesDefault: [{ name: '', email: '' }],
      invites: [{ name: '', email: '' }],
      errorFlag: false,
    }
  },
  computed: {
    companyId() {
      return this.$route.params.companyId
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white px-7.5 pt-4 pb-6 text-xl">
      <span class="">Users</span>
      <span class="breadcrumb-separator">></span>
      <span class="text-blue">Add Users</span>
    </div>
    <div class="bg-white mt-8 mx-7.5 px-8 pt-8 pb-14 rounded-xl shadow-lg">
      <div class="w-2/3 mx-auto">
        <button
          class="button secondary-button text-left text-lg mb-6"
          @click="inviteUser"
        >
          Add another +
        </button>

        <div class="mb-12">
          <div v-for="(user, index) in invites" :key="index" class="flex mb-3">
            <div class="w-1/2 pr-12">
              <BaseInputText v-model="invites[index].name" placeholder="Name" />
            </div>
            <div class="w-1/2 pr-12">
              <BaseInputText
                v-model="invites[index].email"
                placeholder="Email"
              />
            </div>
          </div>
        </div>
        <div
          v-if="errorFlag"
          class="mb-3 text-sm text-center errors text-volunteer_red"
        >
          Please fill in the user name and email.
        </div>
        <div class="flex justify-center">
          <button
            class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5"
            @click="addNewUsers"
          >
            Save
          </button>
          <button
            class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3.5 ml-2"
          >
            <router-link :to="{ name: 'adminUsers' }">
              Return
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </Layout>
</template>
